/**
 * Import the Map implementation the application should use (not the Map class).
 */
import Map from './Mapbox';

export default new Map();
